<script>

import {mapActions, mapState} from "vuex";
import MethodBlock from "@/driver/pages/masters/recycle_disposal_patterns/_MethodBlock.vue";
import FlowBlock from "@/driver/pages/masters/recycle_disposal_patterns/_FlowBlock.vue";
import InfiniteRecycleDisposerAutoComplete from "@/driver/components/InfiniteRecycleDisposerAutoComplete.vue";
import InfiniteTraderLocationAutoComplete from "@/driver/components/InfiniteTraderLocationAutoComplete.vue";
import DownloadMixin from "../../../../mixins/download-mixin";
import ChooseTraderModal from "@/driver/components/ChooseTraderModal.vue";

export default {
  name: "DriverMasterRecycleDisposalPatterns",
  components: {
    ChooseTraderModal,
    InfiniteTraderLocationAutoComplete,
    InfiniteRecycleDisposerAutoComplete,
    FlowBlock,
    MethodBlock
  },
  mixins: [DownloadMixin],
  data () {
    return {
      conditions: {
        selectable_menu: 'method',
        pattern_name: null,
        disposer_id: null,
        disposer_location_id: null,
        disposer_location_code: null,
        recycle_disposal_method_id: null,
        disposal_category_codes: [],
        disposal_subcategory_ids: [],
        recycle_disposal_method_name: null,
        after_disposal_method_ids: [],
        without_invisible: true,
      },
        searchPanel: 0,
        enableTraderModal: false,
        methodPage: 1,
        methodPerPage: 50,
        methods: [],
        methodPagination: {
        current_page: 1,
        total_count: 0,
      },

      flowPage: 1,
      flowPerPage: 50,
      flows: [],
      flowPagination: {
        current_page: 1,
        total_count: 0,
      },
      afterRecycleMethods: [],
      afterDisposalItemCategories: [],
      afterDisposalItemSubcategories: [],
    }
  },
  watch: {},
  computed: {
    ...mapState("DriverMasterRecycleDisposalPatternCondition", [
      "condition",
    ]),
    onlyMethod () {
      return !!(this.$route.query.only_method || this.$route.params.onlyMethod)
    },
    isMethod () {
      return this.conditions.selectable_menu === 'method'
    },
    showToggle () {
      return !this.onlyMethod
    },
  },
  created() {

    if (this.$route.params.resetCondition) {
      this.resetCondition();
    }
    Object.assign(this.conditions, this.condition)
    if (this.onlyMethod) {
      this.conditions.selectable_menu = 'method'
    }
    this.initializeAfterRecycleMethods();

    this.loadAfterDisposalOptions()


    this.searchButtonClickEvent();
  },
  methods: {
    /**
     * 検索条件の保存・リセット
     */
    ...mapActions("DriverMasterRecycleDisposalPatternCondition", {
      saveCondition: "saveCondition",
      resetCondition: "resetState",
    }),
    /**
     * 処分場処理方法
     */
    ...mapActions("DriverMasterRecycleDisposerDisposalMethod", {
      fetchMethods: "index",
    }),
    /**
     * 処理フロー
     */
    ...mapActions("DriverMasterRecycleDisposalFlow", {
      fetchFlows: "index",
    }),
    /**
     * 処分方法
     */
    ...mapActions("DriverMasterSearchAfterRecycleMethod", {
      fetchAfterRecycleMethods: "index"
    }),

    /**
     * 処理後物の大分類
     */
    ...mapActions("DriverMasterSearchRecycleDisposedItemCategory", {
      fetchItemCategories: 'index',
    }),

    ...mapActions("DriverMasterSearchRecycleDisposedItemSubcategory", {
      fetchItemSubcategories: 'index',
    }),

    openChooseTraderModalClickEvent () {
      this.enableTraderModal = true;
    },

    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent() {

      this.flowPage = 1;
      this.methodPage = 1;

      const condition = {
        ...this.conditions,
        limit: this.isMethod ? this.methodPerPage : this.flowPerPage,
      }

      // 検索条件の保存
      this.saveCondition({ condition: condition })

     this.search();
    },

    /**
     * CSV出力ボタン クリックイベント
     */
    exportCsvButtonClickEvent () {
      // 処分場処理方法タブの場合
      if (this.isMethod) {
        this.exportMethodCsv()
      } else {
        // 処理フロータブの場合
        this.exportFlowCsv()
      }
    },

    /**
     * 処分場処理方法 CSV出力
     */
    exportMethodCsv () {
      const params = this.buildMethodParam('csv')
      this.fetchMethods(params).then((content) => {
        this.downloadCsv(content, "再資源化マスタ_処分場処理方法");
      })
    },

    /**
     * 処理フロー CSV出力
     */
    exportFlowCsv () {
      const params = this.buildFlowParam('csv')
      this.fetchFlows(params).then((content) => {
        this.downloadCsv(content, "再資源化マスタ_処理フロー");
      })
    },

    /**
     * 新規追加ボタン クリックイベント
     */
    addButtonClickEvent () {
      if (this.isMethod) {
        this.$router.push({ name: "DriverMasterMethodNew" });
      } else {
        this.$router.push({ name: "DriverMasterFlowNew" });
      }
    },

    /**
     * メニュー チェンジイベント
     */
    menuChangeEvent () {
      this.searchButtonClickEvent();
    },

    patternNameChangedCallback(value) {
      this.conditions.pattern_name = value;
      this.searchButtonClickEvent();
    },

    recycleDisposalMethodNameChangedCallback(value) {
      this.conditions.recycle_disposal_method_name = value;
      this.searchButtonClickEvent();
    },

    afterDisposalMethodIdsChangedCallback(values) {
      this.conditions.after_disposal_method_ids = values;
      this.searchButtonClickEvent();
    },

    methodPageChangeCallback (page) {
      this.methodPage = page;
      this.search();
    },

    methodPerPageChangeCallback (perPage) {
      this.methodPerPage = perPage;
      this.methodPage = 1;
      this.search();
    },

    flowPageChangeCallback (page) {
      this.flowPage = page;
      this.search();
    },

    flowPerPageChangeCallback (perPage) {
      this.flowPerPage = perPage;
      this.flowPage = 1;
      this.search();
    },

    closeModal () {
      this.enableTraderModal = false;
    },

    // 大分類の選択肢を取得し、続けて種類の選択肢も取得する
    loadAfterDisposalOptions () {
      this.fetchItemCategories().then((content) => {
        this.afterDisposalItemCategories = content.after_disposal_items || []
        return this.loadDisposedTypeOptions()
      })
    },
    // 選択中の大分類に紐づく種類の選択肢を取得する（大分類未選択時はクリア）
    loadDisposedTypeOptions () {
      if (this.conditions.disposal_category_codes.length <= 0) {
        this.afterDisposalItemSubcategories = []
        this.conditions.disposal_subcategory_ids = []
        return Promise.resolve()
      }
      this.fetchItemSubcategories({
        disposal_category_codes: this.conditions.disposal_category_codes,
      }).then((content) => {
        this.afterDisposalItemSubcategories = content.after_disposal_items || []
      })
    },


    search () {
      if (this.onlyMethod || this.isMethod) {
        this.searchMethods();
      } else {
        this.searchFlows();
      }
    },

    /**
     * 処分場処理方法一覧の検索処理
     */
    searchMethods () {
      this.fetchMethods({
        condition: this.condition,
        page: this.methodPage,
        limit: this.methodPerPage,
      }).then((content) => {
        this.methods = content.recycle_disposer_disposal_methods;
        this.methodPagination = content.pagination;
      });
    },

    /**
     * 処理フロー一覧の検索処理
     */
    searchFlows () {
      this.fetchFlows({
        condition: this.condition,
        page: this.flowPage,
        limit: this.flowPerPage,
      }).then((content) => {
        this.flows = content.recycle_disposal_flows;
        this.flowPagination = content.pagination;
      })
    },

    initializeAfterRecycleMethods() {
      this.fetchAfterRecycleMethods().then((content) => {
        this.afterRecycleMethods = content.after_recycle_methods;
      });
    },

    /**
     * 処分業者 コールバック
     * @param object { Object }
     */
    disposerChangedCallback (object) {

      if (!object) {
        this.conditions.disposer_id = null;
        this.conditions.disposer_location_id = null;
        this.conditions.disposer_location_code = null;
        this.searchButtonClickEvent();
        return;
      }

      this.conditions.disposer_id = object.id;
      this.searchButtonClickEvent();
    },

    chooseTraderCallback (item) {
      this.conditions.disposer_id = item.id;
      this.closeModal();
    },

    /**
     * 処分事業場 コールバック
     * @param object { Object }
     * @property object.id
     * @property object.code
     * @property object.parent_id
     * @property object.parent_type
     */
    disposerLocationChangeCallback (object) {

      if (!object) {
        this.conditions.disposer_location_id = null;
        this.conditions.disposer_location_code = null;
        this.searchButtonClickEvent();
        return;
      }

      this.conditions.disposer_location_id = object.id;
      this.conditions.disposer_location_code = object.code;

      if (this.conditions.disposer_id !== object.parent_id) {
        this.conditions.disposer_id = object.parent_id;
      }
      this.searchButtonClickEvent();
    },

    // 処分場処理方法用パラメータ生成
    buildMethodParam(format) {
      return {
        condition: this.condition,
        page: this.methodPage,
        limit: this.methodPerPage,
        format: format,
      }
    },
    // 処理フロー用パラメータ生成
    buildFlowParam(format) {
      return {
        condition: this.condition,
        page: this.flowPage,
        limit: this.flowPerPage,
        format: format,
      }
    },
    categoryClick(item) {

      if (this.conditions.disposal_category_codes.includes(item.value)) {
        this.conditions.disposal_category_codes = this.conditions.disposal_category_codes.filter(v => v !== item.value)
      } else {
        this.conditions.disposal_category_codes.push(item.value)
      }
      this.afterDisposalItemCategoryChange();
    },
    subcategoryClick (item) {
      if (this.conditions.disposal_subcategory_ids.includes(item.value)) {
        this.conditions.disposal_subcategory_ids = this.conditions.disposal_subcategory_ids.filter(v => v !== item.value)
      } else {
        this.conditions.disposal_subcategory_ids.push(item.value)
      }
      this.searchButtonClickEvent()
    },
    isCategorySelected(item) {
      return Array.isArray(this.conditions.disposal_category_codes)
        && this.conditions.disposal_category_codes.includes(item.value)
    },
    isSubSelected(item) {
      return Array.isArray(this.conditions.disposal_subcategory_ids)
        && this.conditions.disposal_subcategory_ids.includes(item.value)
    },
    afterDisposalItemCategoryChange () {
      this.loadDisposedTypeOptions()
      this.searchButtonClickEvent()
    },

    clearAfterDisposalItemSubCategories() {
      this.conditions.disposal_subcategory_ids = []
      this.searchButtonClickEvent()

    },
  },
}
</script>

<template>
  <v-container fluid>
    <h2 class="md-5">
      <v-icon>mdi-graph</v-icon>
      <span class="ml-2">再資源化等パターン</span>
    </h2>

    <!-- 検索条件 -->
    <v-expansion-panels
      v-model="searchPanel"
      accordion
      class="my-4"
    >
      <v-expansion-panel>
        <v-expansion-panel-header
          class="panel-header-color panel-selectable"
        >
          <strong>
            <v-icon class="panel-header-color">
              mdi-magnify
            </v-icon>
            &nbsp;条件を指定して検索
          </strong>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text>

              <!-- 処分事業者, 処分事業場 -->
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="conditions.pattern_name"
                    label="パターン名"
                    dense
                    hide-details="auto"
                    clearable
                    outlined
                    rounded
                    persistent-placeholder
                    @change="patternNameChangedCallback"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <infinite-recycle-disposer-auto-complete
                    :disposer-id="conditions.disposer_id"
                    :location-id="conditions.disposer_location_id"
                    :with-none-reporting="true"
                    :with-none-subscribe="true"
                    classes="search-font"
                    rounded
                    @update:values="disposerChangedCallback"
                  >
                    <template v-slot:append-outer>
                      <v-btn
                        color="primary"
                        @click="openChooseTraderModalClickEvent"
                      >
                        選択
                      </v-btn>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-chip
                        color="#e0ffff"
                        drak
                        label
                        small
                      >
                        {{ item.type === 'Trader::FinalDisposer' ? item.code : item.subscriber_number }}
                      </v-chip>&nbsp;
                      {{ item.text }}&nbsp;
                    </template>
                  </infinite-recycle-disposer-auto-complete>
                </v-col>
                <v-col cols="12" md="4">
                  <infinite-trader-location-auto-complete
                    :trader-id="conditions.disposer_id"
                    :location-id="conditions.disposer_location_id"
                    classes="search-font"
                    label="処分事業場"
                    rounded
                    search-type="trader"
                    without-invisible
                    with-final-disposer
                    permit-number-registered-only
                    @update:values="disposerLocationChangeCallback"
                  >
                    <template v-slot:item="{ item }">
                      <v-chip
                        color="#e0ffff"
                        drak
                        label
                        small
                      >
                        {{ item.code }}
                      </v-chip>&nbsp;
                      {{ item.text }}&nbsp;
                    </template>
                  </infinite-trader-location-auto-complete>
                </v-col>
              </v-row>
              <!-- /処分事業者, 処分事業場 -->

              <!-- 処理後物の大分類, 処理簿物の種類 -->
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="conditions.recycle_disposal_method_name"
                    label="処分方法名"
                    dense
                    hide-details="auto"
                    clearable
                    outlined
                    rounded
                    persistent-placeholder
                    @change="recycleDisposalMethodNameChangedCallback"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="conditions.after_disposal_method_ids"
                    :items="afterRecycleMethods"
                    label="処分方法"
                    dense
                    hide-details="auto"
                    clearable
                    outlined
                    rounded
                    multiple
                    persistent-placeholder
                    @change="afterDisposalMethodIdsChangedCallback"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="conditions.disposal_category_codes"
                    :items="afterDisposalItemCategories"
                    class="search-font"
                    clearable
                    dense
                    item-text="text"
                    item-value="value"
                    label="処理後物の大分類名称"
                    multiple
                    hide-details="auto"
                    persistent-placeholder
                    rounded
                    outlined
                    @change="afterDisposalItemCategoryChange"
                  >
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-list-item-action
                        >
                          <v-simple-checkbox
                            :value="isCategorySelected(item)"
                            :input-value="isCategorySelected(item)"
                            @click="categoryClick(item)"
                          />
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-chip
                              small
                              :color="item.after_type === 'after_industrial' ? 'light-blue lighten-4' : 'light-green lighten-4'"
                            >
                              {{ item.after_type === 'after_industrial' ? '廃棄物' : '再資源' }}
                            </v-chip>
                            <span class="ml-3">{{ item.text }}</span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>

                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="conditions.disposal_subcategory_ids"
                    :items="afterDisposalItemSubcategories"
                    class="search-font"
                    clearable
                    dense
                    item-text="text"
                    item-value="value"
                    label="処理後物の種類"
                    multiple
                    hide-details="auto"
                    persistent-placeholder
                    rounded
                    outlined
                    @change="searchButtonClickEvent"
                    @click:clear="clearAfterDisposalItemSubCategories"
                  >
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-list-item-action
                        >
                          <v-simple-checkbox
                            :value="isSubSelected(item)"
                            :input-value="isSubSelected(item)"
                            @click="subcategoryClick(item)"
                          />
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.code }}:{{ item.text }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <!-- /処理後物の大分類, 処理簿物の種類 -->

              <!-- 非表示を表示しない -->
              <v-row>
                <v-col cols="12" md="4">
                  <v-checkbox
                    v-model="conditions.without_invisible"
                    label="非表示を表示しない"
                    dense
                    hide-details="auto"
                    @change="searchButtonClickEvent"
                  />
                </v-col>
              </v-row>
              <!-- /非表示を表示しない -->

            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                @click="searchButtonClickEvent"
              >
                <v-icon>mdi-magnify</v-icon>&nbsp;検索
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <!-- /検索条件 -->

    <!-- ボタン -->
    <v-row class="mb-4">
      <v-col cols="12" md="6">
        <v-btn-toggle
          v-if="showToggle"
          v-model="conditions.selectable_menu"
          class="toggleButton"
          color="info accent-3"
          tile
          light
          mandatory
          rounded
          @change="menuChangeEvent"
        >
          <v-btn
            value="method"
            width="140"
          >
            処分場処理方法
          </v-btn>
          <v-btn
            value="flow"
            width="140"
          >
            処理フロー
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="text-right"
      >
        <v-btn
          color="info"
          class="mr-2"
          @click="exportCsvButtonClickEvent"
        >
          &emsp;CSV出力&emsp;
        </v-btn>
        <v-btn
          color="primary"
          @click="addButtonClickEvent"
        >
          新規追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!-- /ボタン -->

    <!-- 処分場処理方法一覧 -->
    <method-block
      v-if="isMethod"
      :items="methods"
      :page="methodPage"
      :per-page="methodPerPage"
      :pagination="methodPagination"
      @pageChanged="methodPageChangeCallback"
      @perPageChanged="methodPerPageChangeCallback"
    />
    <!-- /処分場処理方法一覧 -->

    <!-- 処理フロー一覧 -->
    <flow-block
      v-else
      :items="flows"
      :page="flowPage"
      :per-page="flowPerPage"
      :pagination="flowPagination"
      @pageChanged="flowPageChangeCallback"
      @perPageChanged="flowPerPageChangeCallback"
    />
    <!-- /処理フロー一覧 -->

    <!-- 処分事業者検索モーダル -->
    <choose-trader-modal
      :enable="enableTraderModal"
      search-type="trader"
      without-invisible
      include-final-disposer
      permit-number-registered-only
      @close="closeModal"
      @selected="chooseTraderCallback"
    />
    <!-- /処分事業者検索モーダル -->

  </v-container>
</template>

<style scoped lang="scss">

</style>
